import { range } from 'lodash'
import { bowserFlags } from 'lib/bowser'
import classNames from 'classnames'
import PropTypes from 'prop-types'

import { InfoButton } from 'components/buttons'
import Link from 'components/link'
import Image from 'components/image'
import showIf from 'lib/show-if'
import * as BLConstants from 'shared/constants'

import { mobileAppDownloadPath } from 'lib/urls'
import css from './app-promo.scss'

const AppPromo = ({
  className,
  ctaText,
  downloadPath,
  hideTitle,
  onInstall,
  onDismiss,
  tinyAppImage,
}) => {
  const getTitle = () => {
    if (bowserFlags.ipad) return 'Babylist for iPad'
    if (bowserFlags.ios) return 'Babylist for iPhone'
    return 'Babylist for Android'
  }

  const title = getTitle()

  return (
    <div className={className}>
      {!hideTitle && (
        <div className="h4 text-center lh-md mvm">
          Add any item from any store on the web with our 5-star rated app!
        </div>
      )}

      <div className={css.promoImage}>
        <a href={downloadPath} onClick={onInstall}>
          <Image
            alt={title}
            src="//res.cloudinary.com/babylist/image/upload/f_auto,q_auto/v1546382898/app-preview_xij24m.png"
            style={{
              height: tinyAppImage ? 120 : 190,
            }}
          />
        </a>
      </div>

      <div className="flex center">
        <a href={downloadPath} onClick={onInstall}>
          <Image
            alt="Download the App"
            className="pull-left mrl"
            src="//res.cloudinary.com/babylist/image/upload/f_auto,q_auto/v1546380990/appstore-icon_h31wf9.png"
            style={{
              width: 74,
            }}
          />
        </a>

        <div>
          <p className="h6 pts mvn">
            <b>{title}</b>
          </p>

          {range(5).map((num) => (
            <i className={classNames('fa fa-star', css.ratingIcon)} key={num} />
          ))}

          <div className="text-muted h6 mtn">
            {bowserFlags.ios
              ? '80,000+ 5 star reviews'
              : '12,000+ 5 star reviews'}
          </div>
        </div>
      </div>

      <div className={css.ctaContainer}>
        <InfoButton block pill href={downloadPath} onClick={onInstall}>
          {ctaText || 'Download App'}
        </InfoButton>
        {showIf(
          onDismiss,
          <div className="mtm">
            <Link className="text-muted h6" onClick={onDismiss}>
              Use the Mobile Site
            </Link>
          </div>
        )}
      </div>
    </div>
  )
}

AppPromo.propTypes = {
  className: PropTypes.string,
  ctaText: PropTypes.string,
  downloadPath: PropTypes.string,
  hideTitle: PropTypes.bool,
  onInstall: PropTypes.func,
  onDismiss: PropTypes.func,
  tinyAppImage: PropTypes.bool,
}

AppPromo.defaultProps = {
  downloadPath: mobileAppDownloadPath(),
  hideTitle: false,
  tinyAppImage: false,
}

export default AppPromo
